var map = {
	"./1.png": 1804,
	"./2.png": 279,
	"./3.png": 2590,
	"./4.png": 5057,
	"./5.png": 8760,
	"./6.png": 1971,
	"./7.png": 394,
	"./73.png": 955,
	"./8.png": 4253,
	"./9.png": 1748,
	"./dd7.png": 1434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6658;